import styled from 'styled-components';

import { IconButton } from '@components/icon-button';
import { IconAI } from '@components/icons/ai';
import { IconCloseRegular } from '@components/icons/close-regular';
import { IconLoop } from '@components/icons/loop';
import { IconMoreVertical } from '@components/icons/more-vertical';
import { Menu } from '@components/menu';
import { Stack } from '@components/stack';
import { Text } from '@components/text';
import { useScopedTranslate } from '@locale/translate';
import { theme } from '@styles/theme';
import { pxToRem } from '@utils/converters';

import { AIBuilderMode } from 'api/ai-builder/requests';

type ChatHeaderProps = {
  mode: AIBuilderMode;
  onClose?: () => void;
  onClearChat: () => void;
  isGenerating: boolean;
  journeyShortId: string;
};

export const ChatHeader = ({ mode, onClose, onClearChat, isGenerating }: ChatHeaderProps) => {
  const { t } = useScopedTranslate(locale);

  return (
    <StyledHeader>
      <Stack space={2} orientation="horizontal" align="center">
        <IconAI color="aiGradientTeal100" />
        <Text font="bold18" color="textPrimary" text={t('navigatorLabel')} />
      </Stack>
      <Stack space={1} orientation="horizontal" align="center">
        <Menu
          trigger={IconButton}
          triggerProps={{
            variant: 'ghost-purple',
            size: 'md',
            icon: <IconMoreVertical />,
          }}
        >
          <Menu.Item
            icon={<IconLoop color="red100" />}
            label={t('clearChat')}
            variant="danger"
            onSelect={onClearChat}
            isDisabled={isGenerating}
          />
        </Menu>
        <IconButton
          icon={<IconCloseRegular />}
          onClick={onClose}
          variant="ghost-purple"
          size="md"
        />
      </Stack>
    </StyledHeader>
  );
};

const StyledHeader = styled(Stack).attrs({
  orientation: 'horizontal',
  justify: 'space-between',
})({
  borderBottom: `1px solid ${theme.color.border10}`,
  padding: `${pxToRem(12)} ${pxToRem(16)}`,
});

const locale = {
  en: {
    navigatorLabel: 'Navigator',
    clearChat: 'Clear chat',
  },
};
